import { render, staticRenderFns } from "./AddHotspot.vue?vue&type=template&id=2620adb7&scoped=true&"
import script from "./AddHotspot.vue?vue&type=script&lang=js&"
export * from "./AddHotspot.vue?vue&type=script&lang=js&"
import style0 from "./AddHotspot.vue?vue&type=style&index=0&id=2620adb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2620adb7",
  null
  
)

export default component.exports